import { Slot } from "@suse-o11y/slot";
import React from "react";

const DialogTrigger = React.lazy(async () => {
	const Dialog = await import("@radix-ui/react-dialog");

	return { default: Dialog.Trigger };
});

export type TriggerProps = React.ComponentPropsWithoutRef<typeof DialogTrigger>;

export const Trigger = React.forwardRef<React.ComponentRef<typeof DialogTrigger>, TriggerProps>(
	({ asChild, ...props }, ref) => (
		<React.Suspense fallback={asChild ? <Slot ref={ref} {...props} /> : <button ref={ref} type="button" {...props} />}>
			<DialogTrigger asChild={asChild} ref={ref} {...props} />
		</React.Suspense>
	),
);

Trigger.displayName = "Dialog.Trigger";
